export default __webpack_public_path__ + "static/media/dashboard.fd254a2b.svg";